module.exports = __webpack_public_path__ + "img/Weapon_91.2c5f6fa6.png";